import React, { useContext } from 'react'
import '../App.css'
import {AuthContext} from '../context/AuthContext'
const Topnav = () => {
  const {currentuser} = useContext(AuthContext);
  console.log(currentuser.displayName)
  console.log(currentuser)
  if (!currentuser) {
    return <div>Loading...</div>;
  }
  return (
    <div className='chat-nav'>
        <div className='chat-user'>
            <img src={currentuser.photoURL} alt=" " />
            <span className='nav-user-name'>{currentuser.displayName}</span>
        </div>
    </div>
  )
}

export default Topnav